import React from 'react';
import { usePortfolio } from '../context/PortfolioContext';
import './TopStocks.css';

const TopStocks: React.FC = () => {
  const { state } = usePortfolio();
  const { stocks } = state;

  // Sort stocks by change percentage (top performers first)
  const topStocks = [...stocks]
    .sort((a, b) => b.changePercent - a.changePercent)
    .slice(0, 5);

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const formatPercent = (percent: number) => {
    return `${percent >= 0 ? '+' : ''}${percent.toFixed(2)}%`;
  };

  return (
    <div className="top-stocks">
      <div className="stocks-header">
        <h3>Top Performers</h3>
        <span className="stocks-subtitle">Real-time market data</span>
      </div>

      <div className="stocks-list">
        {topStocks.map((stock, index) => (
          <div key={stock.ticker} className="stock-item">
            <div className="stock-rank">
              #{index + 1}
            </div>
            <div className="stock-info">
              <div className="stock-ticker">{stock.ticker}</div>
              <div className="stock-name">{stock.name}</div>
            </div>
            <div className="stock-price">
              <div className="price-value">{formatCurrency(stock.currentPrice)}</div>
              <div className={`price-change ${stock.change >= 0 ? 'positive' : 'negative'}`}>
                {formatCurrency(stock.change)} ({formatPercent(stock.changePercent)})
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="stocks-footer">
        <button className="view-all-btn">
          View All Stocks
        </button>
      </div>
    </div>
  );
};

export default TopStocks;
